import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6346ef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CreateList_Title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  class: "CreateList_operationWrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_message" }, "リスト一覧へ戻る", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "error-message pl-3" }, "*必須項目", -1))
const _hoisted_9 = { class: "CreateList_BtnBlock" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "loading"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "loading"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "アップロード", -1))
const _hoisted_15 = { class: "CreateList_TableContainer" }
const _hoisted_16 = { class: "CreateList_Table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("リスト名"),
  /*#__PURE__*/_createElementVNode("span", { class: "error-message pl-3" }, "*")
], -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "error-message"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "説明", -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "error-message"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "画像", -1))
const _hoisted_24 = { class: "CreateList_Table_Img" }
const _hoisted_25 = { class: "CreateList_Table_Imgprev" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "error-message"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "添付ファイル", -1))
const _hoisted_29 = { class: "CreateList_Table_File" }
const _hoisted_30 = {
  key: 0,
  class: "CreateList_Table_Fileprev"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-message" }, " 〇新規ファイルを登録した場合、保存済ファイルは削除されます ", -1))
const _hoisted_32 = { class: "file_flex" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 1,
  class: "loading"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("表示期間"),
  /*#__PURE__*/_createElementVNode("span", { class: "error-message pl-3" }, "*")
], -1))
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "CreateList_MukigenCheck" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mukigenCheck" }, "無期限", -1))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "error-message"
}
const _hoisted_42 = { class: "tr_syosi" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("書誌"),
  /*#__PURE__*/_createElementVNode("span", { class: "error-message pl-3" }, "*")
], -1))
const _hoisted_44 = {
  key: 0,
  class: "CreateList_Table_SearchSyosi"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "cdSearch" }, "書誌検索", -1))
const _hoisted_46 = {
  key: 0,
  class: "error-message"
}
const _hoisted_47 = {
  key: 1,
  class: "syosi_table_container"
}
const _hoisted_48 = {
  key: 0,
  class: "syosi_table_info"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-message" }, " 〇ドラッグ&ドロップで並び替えができます ", -1))
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "syosi_table_content" }
const _hoisted_52 = { style: {"margin-bottom":"10px"} }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN13桁"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("出版社書誌CD")
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"240px"} }, "書誌名"),
    /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px"} }, "著者"),
    /*#__PURE__*/_createElementVNode("th", null, "削除")
  ])
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = { style: {"text-align":"right"} }
const _hoisted_57 = { style: {"text-align":"center"} }
const _hoisted_58 = {
  key: 2,
  class: "ResultMessageNull"
}
const _hoisted_59 = {
  key: 4,
  class: "CreateList_BtnBlock"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_message" }, "キャンセル", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_message" }, "登録", -1))
const _hoisted_63 = [
  _hoisted_62
]

import PankuzuHeader from "../components/PankuzuHeader.vue";
import ModalSyosiList, {
  ZaikoData_Result,
} from "@/components/modal/ModalSyosiList.vue";
import { nextTick, reactive, ref, watch } from "vue";
import {
  RouteLocationNormalized,
  onBeforeRouteLeave,
  useRoute,
  useRouter,
} from "vue-router";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import axios, { AxiosResponse } from "axios";
import { ZaikoData } from "@/types/zaiko";
import ModalWarningMessage from "@/components/modal/ModalWarningMessage.vue";
import * as xlsx from "xlsx";
import mediumZoom from "medium-zoom";
import draggable from "vuedraggable";

//ぱんくずヘッダー

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNewList',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const currentPathList = [{ name: "受注入力" }, { name: "新規注文リスト作成" }];
// ナビゲーションガード---------------------------------------------
// 未更新データがある場合、画面遷移前に確認する
let navTo: RouteLocationNormalized; // ナビゲーション先
let fromModalNav = false; // モーダルから遷移する場合はダイアログを表示させないようにするフラグ
onBeforeRouteLeave(async (to, from) => {
  // ダイアログ表示
  if (isCreateNewList) {
    if (
      (inputItem.value.listName !== "" ||
        inputItem.value.explanation !== "" ||
        inputImg.value.files[0] !== undefined ||
        inputItem.value.startDate !== "" ||
        inputItem.value.endDate !== "" ||
        inputItem.value.syosiList.length > 0) &&
      !fromModalNav
    ) {
      navTo = to;
      warningModalVisible.value = true;
      return false;
    }
  } else {
    if (
      (inputItem.value.listName !== savedListData.value.listName ||
        inputItem.value.explanation !== savedListData.value.description ||
        inputItem.value.startDate !== savedListData.value.startDate ||
        inputItem.value.endDate !== savedListData.value.endDate ||
        imgUrl.value !== savedListData.value.imageUrl ||
        compareSyosiData()) &&
      !fromModalNav
    ) {
      navTo = to;
      warningModalVisible.value = true;
      return false;
    }
  }
});
// 保存データと入力データの書誌を比べる
const compareSyosiData = () => {
  const inputJanArray = inputItem.value.syosiList.map((syosi) => syosi.janCd);
  const savedJanArray = savedListData.value.syosiList.map(
    (syosi) => syosi.janCd
  );
  return (
    [...inputJanArray, ...savedJanArray].filter(
      (janCd) =>
        (inputJanArray.includes(janCd) && !savedJanArray.includes(janCd)) ||
        (!inputJanArray.includes(janCd) && savedJanArray.includes(janCd))
    ).length > 0
  );
};

// 初期設定------------------------------------------------------
const notyf = new Notyf();
const router = useRouter();
const route = useRoute();
const store = useStore();
const props = __props;
const emit = __emit;
// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

// 表示データ関連--------------------------------------------------
const isCreateNewList = route.params.id === "-1" ? true : false; // 新規作成:true/既存データの編集:false
const fromDashboard = Number(route.query.fromDashboard) === 1 ? true : false; // ダッシュボードの操作ログ参照か否か

if (fromDashboard) {
  emit("toggleGlobalHeader");
}
// 入力項目
const inputItem = ref({
  listName: "",
  startDate: "",
  endDate: "",
  explanation: "",
  syosiList: [
    {
      syosiCd: "",
      syuppanSyosiCd: "",
      janCd: "",
      title: "",
      hontaiPrice: -1,
      author: "",
    },
  ],
});
const inputSearchCode = ref("");
// created時にsyosiListをリセットする
inputItem.value.syosiList.splice(0);

// APIからの取得データを保持
const savedListData = ref({
  description: "",
  endDate: "",
  expired: false,
  hanmotoCd: "",
  imageUrl: null as string | null,
  listId: null as number | null,
  listName: "",
  registerDate: "",
  startDate: "",
  userId: -1,
  userName: null as string | null,
  attatchedFileName: null as string | null,
  syosiList: [] as ZaikoData[],
  version: -1,
});

// 表示期間の無期限チェック
const isIndefinite = ref(false);

// 表示データ取得
const getListData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/compile/list-detail-display?listId=${route.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    // 戻り値を保存
    savedListData.value = res.data;
    savedListData.value.startDate =
      savedListData.value.startDate === null
        ? ""
        : savedListData.value.startDate;
    savedListData.value.endDate =
      savedListData.value.endDate === "9999-12-31"
        ? ""
        : savedListData.value.endDate;
    if (
      savedListData.value.imageUrl !== null &&
      !savedListData.value.imageUrl.includes("juchu-connect")
    ) {
      savedListData.value.imageUrl = `data:image;base64,${savedListData.value.imageUrl}`;
    } else if (savedListData.value.imageUrl === null) {
      savedListData.value.imageUrl = "";
    }
    // savedListData.value.imageUrl =
    //   savedListData.value.imageUrl !== null
    //     ? `data:image/png;base64,${savedListData.value.imageUrl}`
    //     : "";
    // 表示用配列に格納
    inputItem.value.listName = savedListData.value.listName;
    inputItem.value.explanation = savedListData.value.description;
    inputItem.value.startDate = savedListData.value.startDate;
    inputItem.value.endDate = savedListData.value.endDate;
    imgUrl.value =
      savedListData.value.imageUrl !== null ? savedListData.value.imageUrl : "";
    savedListData.value.syosiList.forEach((syosi: ZaikoData) => {
      inputItem.value.syosiList.push({
        syosiCd: syosi.syosiCd,
        syuppanSyosiCd: syosi.syuppanSyosiCd,
        janCd: syosi.janCd,
        title: syosi.title,
        hontaiPrice: syosi.hontaiPrice,
        author: createAuthorData(syosi),
      });
    });
    // 表示期限が無期限だったらフラグを立てる
    if (
      savedListData.value.startDate === "" &&
      savedListData.value.endDate === ""
    ) {
      isIndefinite.value = true;
    }
    await nextTick();
    mediumZoom(document.querySelectorAll("img"), {
      background: "#696969",
      scrollOffset: 100,
      container: {
        top: 30,
        bottom: 30,
      },
    });
  } catch (error) {
    console.log(error);
    alert("リストデータが取得できませんでした");
  }
};
if (!isCreateNewList) getListData();

// バリデーション関連-----------------------------------------------------
// リスト名
const listNameError = ref({
  hasError: false,
  message: "",
});
// 説明文
const explanationError = ref({
  hasError: false,
  message: "",
});
// 画像
const imgError = ref({
  hasError: false,
  message: "",
});
// 表示期間
const displayPeriodError = ref({
  hasError: false,
  message: "",
});
// 書誌
const syosiError = ref({
  hasError: false,
  message: "",
});
// 即時バリデーション---------------
watch(
  () => inputItem.value.explanation,
  (explanation) => {
    // 説明文
    if (explanation.length > 40) {
      explanationError.value.hasError = true;
      explanationError.value.message = "説明は40文字以内で入力してください";
    } else {
      explanationError.value.hasError = false;
      explanationError.value.message = "";
    }
  }
);
watch(
  () => [
    {
      startDate: inputItem.value.startDate,
      endDate: inputItem.value.endDate,
      isIndefinite: isIndefinite.value,
    },
  ],
  (date) => {
    // 表示期間
    if (
      date[0].startDate !== "" &&
      date[0].endDate !== "" &&
      !isIndefinite.value
    ) {
      if (date[0].startDate > date[0].endDate) {
        displayPeriodError.value.hasError = true;
        displayPeriodError.value.message = "開始日が終了日を上回っています";
      } else {
        displayPeriodError.value.hasError = false;
        displayPeriodError.value.message = "";
      }
    } else {
      displayPeriodError.value.hasError = false;
      displayPeriodError.value.message = "";
    }
  }
);
// 画像
const validImg = (size: number) => {
  const limitSize = 1000000; // サイズ上限3MB
  if (size > limitSize) {
    imgError.value.hasError = true;
    imgError.value.message = `ファイルの上限サイズ${
      limitSize / 1000000
    }MBを超えています`;
    return true;
  } else {
    imgError.value.hasError = false;
    imgError.value.message = "";
    return false;
  }
};

// 登録時バリデーション-------------
const validateOnRegister = () => {
  // 表示期間
  if (!displayPeriodError.value.hasError) {
    displayPeriodError.value.hasError = false;
    displayPeriodError.value.message = "";
    if (
      !isIndefinite.value &&
      (inputItem.value.startDate === "" || inputItem.value.endDate === "")
    ) {
      displayPeriodError.value.hasError = true;
      displayPeriodError.value.message = "表示期間を入力してください";
    }
  }
  // リスト名
  if (inputItem.value.listName === "") {
    listNameError.value.hasError = true;
    listNameError.value.message = "リスト名を入力してください";
  } else {
    listNameError.value.hasError = false;
    listNameError.value.message = "";
  }
  // 書誌
  if (inputItem.value.syosiList.length === 0) {
    syosiError.value.hasError = true;
    syosiError.value.message = "書誌を選択してください";
  } else {
    syosiError.value.hasError = false;
    syosiError.value.message = "";
  }

  // エラーの有無を返す
  if (
    listNameError.value.hasError ||
    explanationError.value.hasError ||
    imgError.value.hasError ||
    displayPeriodError.value.hasError ||
    syosiError.value.hasError
  ) {
    return true;
  } else {
    return false;
  }
};

// 書誌関連--------------------------------------------------
// 書誌検索モーダル
const syosiModalVisible = ref(false); // 表示制御フラグ
// 直接コード入力されたとき↓↓
const searchSyosi = async (event: any): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (event.target.value === "") {
    inputSearchCode.value = "";
  } else {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi?syosiCd=${event.target.value}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data.syosiList.length > 0) {
      ref_selectSyosi(res.data.syosiList[0]);
    } else {
      //該当する書店が無ければエラーメッセージ表示
      inputSearchCode.value = "";
      notyf.error("該当する書誌がありません");
    }
  }
};
// モーダルから検索されたとき↓↓
const openSearchSyosiModal = () => {
  syosiModalVisible.value = true;
};
// 単独選択
const ref_selectSyosi = (selectedValue: ZaikoData) => {
  if (checkDuplicatedSyosi(selectedValue.janCd)) {
    notyf.error("この書誌は既に追加されています");
  } else {
    inputItem.value.syosiList.push({
      syosiCd: selectedValue.syosiCd,
      syuppanSyosiCd: selectedValue.syuppanSyosiCd,
      janCd: selectedValue.janCd,
      title: selectedValue.title,
      hontaiPrice: selectedValue.hontaiPrice,
      author: createAuthorData(selectedValue),
    });
    notyf.success("書誌を追加しました");
  }
  inputSearchCode.value = "";
};
// 一括選択
const ref_selectMultiSyosi = (selectedSyosiList: ZaikoData_Result[]) => {
  selectedSyosiList.forEach((syosi) => {
    const { selectFlg, ...selectedValue } = syosi;
    if (!checkDuplicatedSyosi(syosi.janCd as string)) {
      inputItem.value.syosiList.push({
        syosiCd: selectedValue.syosiCd as string,
        syuppanSyosiCd: selectedValue.syuppanSyosiCd,
        janCd: selectedValue.janCd as string,
        title: selectedValue.title,
        hontaiPrice: selectedValue.hontaiPrice as number,
        author: createAuthorData(selectedValue),
      });
    }
  });
  notyf.success("書誌を追加しました(追加済の書誌はスキップ)");
};
// 重複した書誌データがあったらエラー
const checkDuplicatedSyosi = (janCd: string) => {
  let isDuplicated = false;
  inputItem.value.syosiList.forEach((syosi) => {
    if (syosi.janCd === janCd) isDuplicated = true;
  });
  return isDuplicated;
};
// 著者情報を連結する
const createAuthorData = (selectedValue: ZaikoData) => {
  let returnAuthor = "";
  if (selectedValue.author1 !== null && selectedValue.author1 !== "") {
    returnAuthor = selectedValue.author1;
  }
  if (selectedValue.author2 !== null && selectedValue.author2 !== "") {
    if (returnAuthor !== "") returnAuthor += ",";
    returnAuthor += selectedValue.author2;
  }
  if (selectedValue.author3 !== null && selectedValue.author3 !== "") {
    if (returnAuthor !== "") returnAuthor += ",";
    returnAuthor += selectedValue.author3;
  }
  return returnAuthor;
};

// 書誌削除
const deleteSyosi = (index: number) => {
  let deleteTitle = inputItem.value.syosiList[index].title;
  inputItem.value.syosiList.splice(index, 1);
  notyf.success(`${deleteTitle}を削除しました`);
};
// 書誌全削除
const deleteAllSyosi = () => {
  if (confirm("書誌を全て削除してよろしいですか？")) {
    inputItem.value.syosiList.splice(0);
  }
};

// キャンセルボタン---------------------------------------------
const onClickCancel = () => {
  router.push("/createList");
};
// 確認モーダル関連
const warningModalVisible = ref(false);
const excuteTransition = () => {
  fromModalNav = true;
  router.push(navTo.path);
};

// 画像ファイルのアップロード------------------------------------
const inputImg = ref();
const imgUrl = ref("");
const onClickInputImg = () => {
  inputImg.value.click();
};
const uploadImg = () => {
  const img = inputImg.value.files[0];
  if (img === undefined) {
    validImg(0);
    imgUrl.value =
      savedListData.value.imageUrl !== null ? savedListData.value.imageUrl : "";
  } else {
    validImg(img.size);
    imgUrl.value = URL.createObjectURL(img);
  }
};

// 添付ファイル関連----------------------------------------------
// ダウンロード
const isAttachedDownloading = ref(false);
const getAttachedFile = async () => {
  isAttachedDownloading.value = true;
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/compile/attached-file-download?syosiListId=${savedListData.value.listId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    downloadAttachedFile(res);
  } catch (error) {
    isAttachedDownloading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadAttachedFile = (resData: any) => {
  console.log(resData);
  let blob = new Blob([resData.data], {
    type: resData.headers["content-type"],
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = savedListData.value.attatchedFileName as string;
  link.click();
  isAttachedDownloading.value = false;
};
// ファイル添付用input
const inputAttachedFile = ref();

// Excel関連-----------------------------------------------------
// ダウンロード関連
const isDownloading = ref(false); // ダウンロード中フラグ
// ダウンロード処理
const getExcelData = async () => {
  isDownloading.value = true;
  try {
    const url = `${store.getters["getBaseUrl"]}/compile/template-excel`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      responseType: "arraybuffer",
      responseEncoding: "binary",
    });
    downloadFile(res);
  } catch (error) {
    isDownloading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadFile = (resData: any) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `注文リスト作成.xlsx`;
  link.click();
  isDownloading.value = false;
};

const isUploading = ref(false); // アップロード中フラグ
const inputFile = ref();
let error = reactive({
  hasError: false,
  message: "",
});
watch(
  () => error,
  () => {
    if (error.hasError === true) {
      isUploading.value = false;
      notyf.error({
        duration: 10000,
        message: error.message,
      });
    }
  },
  { deep: true }
);
const onClickUpload = () => {
  //「アップロード」ボタンを押下すると非表示中のinput=fileが発火する
  inputFile.value.click();
};
const resetFile = (e: any) => {
  e.target.value = "";
  error.hasError = false;
  error.message = "";
};
const uploadFile = (e: any) => {
  isUploading.value = true;
  const FILE = e.target.files[0];
  const READER = new FileReader();

  READER.onload = async (e: any) => {
    const Utils = xlsx.utils; // XLSX.utilsのalias
    // ブラウザからのファイルリード結果を変数に保存
    let DATA = e.target.result;
    let arr = fixdata(DATA);
    let wb;
    wb = xlsx.read(btoa(arr), {
      type: "base64",
      cellDates: true,
    });
    const sheetNames = wb.SheetNames;

    // wbの空セルがundefinedになるため空文字を入れる
    const fillCell = (workSheet: xlsx.WorkSheet) => {
      // const sheetNames = wb.SheetNames;
      // const workSheet = wb.Sheets[sheetNames[1]];

      // セルの範囲
      const range = workSheet["!ref"];
      if (range !== undefined) {
        // セル範囲を数値表現に変換
        const decodeRange = Utils.decode_range(range as string);

        for (
          let rowIndex = decodeRange.s.r;
          rowIndex <= decodeRange.e.r;
          rowIndex++
        ) {
          for (
            let colIndex = decodeRange.s.c;
            colIndex <= decodeRange.e.c;
            colIndex++
          ) {
            // 数値表現をセルアドレス ("A1"など) に変換
            const address = Utils.encode_cell({ r: rowIndex, c: colIndex });
            let cell = workSheet[address];

            if (typeof cell === "undefined" || typeof cell.v === "undefined") {
              workSheet[address] = { t: "s", v: "", w: "" };
            }
          }
        }
        // xlsx.writeFile(wb)
      }
      return workSheet;
    };

    const formData = new FormData();
    formData.append("multipartFile", FILE);
    uploadToServer(formData);
  };
  // Fileオブジェクトバイナリデータとしてメモリ上に読み込む（読み込んだらonload部分を実行する）
  READER.readAsArrayBuffer(FILE);
};
//EXCELファイルの読み込み
const fixdata = (DATA: any) => {
  let o = "",
    l = 0,
    w = 10240;
  for (; l < DATA.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(DATA.slice(l * w, l * w + w)) as any
    );
  o += String.fromCharCode.apply(
    null,
    new Uint8Array(DATA.slice(l * w)) as any
  );
  return o;
};
// サーバーに投げる
const uploadToServer = async (sendData: any) => {
  const url = `${store.getters["getBaseUrl"]}/compile/upload-excel`;
  try {
    let isAccept = true;
    if (
      (isCreateNewList &&
        (inputItem.value.listName !== "" ||
          inputItem.value.explanation !== "" ||
          inputImg.value.files[0] !== undefined ||
          inputItem.value.startDate !== "" ||
          inputItem.value.endDate !== "" ||
          inputItem.value.syosiList.length > 0)) ||
      !isCreateNewList
    ) {
      isAccept = confirm("入力データが削除されますがよろしいですか？");
    }
    if (isAccept) {
      const res = await axios.post(url, sendData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "content-type": "multipart/form-data",
        },
      });
      // エラーの削除
      listNameError.value.hasError = false;
      explanationError.value.hasError = false;
      displayPeriodError.value.hasError = false;
      syosiError.value.hasError = false;
      // 表示期限のエラーバリデーションを発火させたいので一旦削除する
      inputItem.value.startDate = "";
      inputItem.value.endDate = "";
      // 各値の代入
      inputItem.value.listName = res.data.listName;
      inputItem.value.startDate =
        res.data.startDate === null ? "" : res.data.startDate;
      inputItem.value.endDate =
        res.data.endDate === null ? "" : res.data.endDate;
      inputItem.value.explanation = res.data.description;
      inputItem.value.syosiList.splice(0);
      // 戻り値の書誌を登録順に並び替える
      res.data.syosiDetailList.sort(
        (
          a: { janCd: string; sequenceNumber: number },
          b: { janCd: string; sequenceNumber: number }
        ) => a.sequenceNumber - b.sequenceNumber
      );
      for (let syosi of res.data.syosiDetailList) {
        const janSearchRes = await axios.get(
          `${store.getters["getBaseUrl"]}/syosi?typeOfCode=isbn&syosiCd=${syosi.janCd}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        inputItem.value.syosiList.push({
          syosiCd: janSearchRes.data.syosiList[0].syosiCd,
          syuppanSyosiCd: janSearchRes.data.syosiList[0].syuppanSyosiCd,
          janCd: janSearchRes.data.syosiList[0].janCd,
          title: janSearchRes.data.syosiList[0].title,
          hontaiPrice: janSearchRes.data.syosiList[0].hontaiPrice,
          author: createAuthorData(janSearchRes.data.syosiList[0]),
        });
      }

      isUploading.value = false;
    } else {
      isUploading.value = false;
    }
  } catch (error) {
    console.log(error);
    isUploading.value = false;
    if (axios.isAxiosError(error) && error.response?.data.userMessage) {
      // console.log(error.response?.status);
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
    } else if (axios.isAxiosError(error) && error.response?.status === 500) {
      notyf.error({
        duration: 10000,
        message: "フォーマットが異なるためアップロードできません",
      });
    }
  }
};

// 登録関連------------------------------------------------------
const registerList = async () => {
  const hasError = validateOnRegister();
  if (hasError) {
    notyf.error("入力内容を確認してください");
  } else {
    try {
      let listData = {
        listName: inputItem.value.listName,
        version: savedListData.value.version,
        description: inputItem.value.explanation,
        startDate: isIndefinite.value ? null : inputItem.value.startDate,
        endDate: isIndefinite.value ? null : inputItem.value.endDate,
        syosiDetailList: [
          {
            janCd: "",
            sequenceNumber: -1,
          },
        ],
      };
      listData.syosiDetailList.splice(0);
      inputItem.value.syosiList.forEach((syosi, index) => {
        listData.syosiDetailList.push({
          janCd: syosi.janCd,
          sequenceNumber: index + 1,
        });
      });
      // console.log(listData.syosiDetailList);

      let postData = new FormData();
      postData.append(
        "listData",
        new Blob([JSON.stringify(listData)], { type: "application/json" })
      );
      postData.append(
        "imageFile",
        inputImg.value.files[0] !== undefined ? inputImg.value.files[0] : null
      );
      postData.append(
        "attatchedFile",
        inputAttachedFile.value.files[0] !== undefined
          ? inputAttachedFile.value.files[0]
          : null
      );
      let res: AxiosResponse<any, any>;
      if (isCreateNewList) {
        res = await axios.post(
          `${store.getters["getBaseUrl"]}/compile/syosi`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        notyf.success("リストを作成しました");
      } else {
        postData.append("listId", String(route.params.id));
        res = await axios.patch(
          `${store.getters["getBaseUrl"]}/compile/edit`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        notyf.success("リストを更新しました");
      }
      fromModalNav = true;
      router.push("/createList");
    } catch (error) {
      console.log(error);
      if (
        axios.isAxiosError(error) &&
        (error.response?.status === 400 ||
          error.response?.status === 409 ||
          error.response?.status === 415)
      ) {
        notyf.error({
          duration: 10000,
          message: error.response.data.userMessage,
        });
      } else {
        alert("注文リスト作成に失敗しました");
      }
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CreateList", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
      CreateList_FromDashboard: _unref(fromDashboard),
    }])
  }, [
    (!_unref(fromDashboard))
      ? (_openBlock(), _createBlock(PankuzuHeader, {
          key: 0,
          isActive_SidebarFlg: props.isActive_SidebarFlg,
          currentPathList: currentPathList
        }, null, 8, ["isActive_SidebarFlg"]))
      : _createCommentVNode("", true),
    (syosiModalVisible.value)
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 1,
          "ikkatu-flg": true,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (syosiModalVisible.value = false)),
          onRef_selectSyosi: ref_selectSyosi,
          onRef_selectMultiSyosi: ref_selectMultiSyosi
        }))
      : _createCommentVNode("", true),
    (warningModalVisible.value)
      ? (_openBlock(), _createBlock(ModalWarningMessage, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (warningModalVisible.value = false)),
          onExecute: excuteTransition,
          message: '入力データが削除されますがよろしいですか？'
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isCreateNewList))
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "新規注文リスト作成"))
        : (_unref(fromDashboard))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "注文リスト参照"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "注文リスト編集"))
    ]),
    (!_unref(fromDashboard))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", { style: {"display":"flex"} }, [
            _createElementVNode("button", {
              onClick: onClickCancel,
              class: "CreateList_BtnGray"
            }, _hoisted_7),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["CreateList_BtnGreen", { disabled_btn: isDownloading.value }]),
              onClick: getExcelData,
              disabled: isDownloading.value
            }, [
              (!isDownloading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "download",
                    style: {"display":"inline-block"}
                  }))
                : _createCommentVNode("", true),
              (isDownloading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              _createTextVNode(" ダウンロード ")
            ], 10, _hoisted_10),
            _createElementVNode("input", {
              onChange: uploadFile,
              onClick: resetFile,
              type: "file",
              ref_key: "inputFile",
              ref: inputFile,
              accept: ".xlsx",
              style: {"display":"none"}
            }, null, 544),
            _createElementVNode("button", {
              onClick: onClickUpload,
              class: _normalizeClass(["CreateList_BtnGreen", { disabled_btn: isUploading.value }]),
              disabled: isUploading.value
            }, [
              (!isUploading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "upload",
                    style: {"display":"inline-block"}
                  }))
                : _createCommentVNode("", true),
              (isUploading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true),
              _hoisted_14
            ], 10, _hoisted_12)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("table", _hoisted_16, [
        _createElementVNode("tr", null, [
          _hoisted_17,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputItem.value.listName) = $event)),
              type: "text",
              class: "Input_Long",
              disabled: _unref(fromDashboard)
            }, null, 8, _hoisted_18), [
              [_vModelText, inputItem.value.listName]
            ]),
            (listNameError.value.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(listNameError.value.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_20,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputItem.value.explanation) = $event)),
              disabled: _unref(fromDashboard)
            }, null, 8, _hoisted_21), [
              [_vModelText, inputItem.value.explanation]
            ]),
            (explanationError.value.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(explanationError.value.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_23,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (imgUrl.value === '')
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "image",
                      class: "img_icon"
                    }))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: imgUrl.value
                    }, null, 8, _hoisted_26))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  onChange: uploadImg,
                  type: "file",
                  ref_key: "inputImg",
                  ref: inputImg,
                  accept: "image/*",
                  style: {"display":"none"}
                }, null, 544),
                (!_unref(fromDashboard))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "CreateList_BtnGreen",
                      onClick: onClickInputImg
                    }, " 画像選択 "))
                  : _createCommentVNode("", true),
                (imgError.value.hasError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(imgError.value.message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_28,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_29, [
              (!_unref(isCreateNewList))
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", null, "保存済ファイル：" + _toDisplayString(savedListData.value.attatchedFileName === null
                        ? "なし"
                        : savedListData.value.attatchedFileName), 1),
                      (savedListData.value.attatchedFileName !== null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: getAttachedFile,
                            class: _normalizeClass(["CreateList_BtnGreen file_download_btn", { disabled_btn: isAttachedDownloading.value }]),
                            disabled: isAttachedDownloading.value
                          }, [
                            (!isAttachedDownloading.value)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  icon: "download",
                                  style: {"display":"inline-block"}
                                }))
                              : _createCommentVNode("", true),
                            (isAttachedDownloading.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                              : _createCommentVNode("", true),
                            _createTextVNode(" ダウンロード ")
                          ], 10, _hoisted_33))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (!_unref(fromDashboard))
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "file",
                      ref_key: "inputAttachedFile",
                      ref: inputAttachedFile,
                      accept: ".xls,.xlsx,application/pdf,.doc,.docx,.ppt,.pptx",
                      style: {"min-width":"125px"}
                    }, null, 512))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_35,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputItem.value.startDate) = $event)),
              type: "date",
              class: "Input_Short",
              disabled: isIndefinite.value || _unref(fromDashboard)
            }, null, 8, _hoisted_36), [
              [_vModelText, inputItem.value.startDate]
            ]),
            _createTextVNode(" ~ "),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputItem.value.endDate) = $event)),
              type: "date",
              class: "Input_Short",
              disabled: isIndefinite.value || _unref(fromDashboard)
            }, null, 8, _hoisted_37), [
              [_vModelText, inputItem.value.endDate]
            ]),
            _createElementVNode("span", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "mukigenCheck",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isIndefinite).value = $event)),
                disabled: _unref(fromDashboard)
              }, null, 8, _hoisted_40), [
                [_vModelCheckbox, isIndefinite.value]
              ])
            ]),
            (displayPeriodError.value.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(displayPeriodError.value.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("td", null, [
            (!_unref(fromDashboard))
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _withDirectives(_createElementVNode("input", {
                    id: "cdSearch",
                    class: "CreateList_Table_Inputdblclick",
                    type: "text",
                    placeholder: "商品コード",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inputSearchCode).value = $event)),
                    onDblclick: _cache[8] || (_cache[8] = ($event: any) => (openSearchSyosiModal())),
                    onChange: searchSyosi
                  }, null, 544), [
                    [_vModelText, inputSearchCode.value]
                  ]),
                  (syosiError.value.hasError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(syosiError.value.message), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (inputItem.value.syosiList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  (!_unref(fromDashboard))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("button", {
                          onClick: deleteAllSyosi,
                          class: _normalizeClass(["CreateList_BtnGreen", { disabled_btn: isAttachedDownloading.value }]),
                          disabled: isAttachedDownloading.value
                        }, " すべて削除 ", 10, _hoisted_50)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("table", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_unref(draggable), {
                        modelValue: inputItem.value.syosiList,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((inputItem.value.syosiList) = $event)),
                        disabled: _unref(fromDashboard),
                        group: "syosi",
                        tag: "tbody",
                        "item-key": "janCd"
                      }, {
                        item: _withCtx(({ element: item, index: itemIndex }) => [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(item.syosiCd), 1),
                              _hoisted_54,
                              _createTextVNode(_toDisplayString(item.janCd), 1),
                              _hoisted_55,
                              _createTextVNode(_toDisplayString(item.syuppanSyosiCd), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.title), 1),
                            _createElementVNode("td", _hoisted_56, _toDisplayString(item.hontaiPrice.toLocaleString()) + "円 ", 1),
                            _createElementVNode("td", null, _toDisplayString(item.author), 1),
                            _createElementVNode("td", _hoisted_57, [
                              (!_unref(fromDashboard))
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    onClick: ($event: any) => (deleteSyosi(itemIndex)),
                                    class: "CreateList_Table_Icon",
                                    icon: "trash-can"
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_58, " 書誌を追加するとここに表示されます "))
          ])
        ])
      ])
    ]),
    (!_unref(fromDashboard))
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _createElementVNode("button", {
            onClick: onClickCancel,
            class: "CreateList_BtnGray"
          }, _hoisted_61),
          _createElementVNode("button", {
            onClick: registerList,
            class: "CreateList_BtnGreen"
          }, _hoisted_63)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})